/**
 *
 * @typedef PersonalData
 * @returns {{get(): Promise, save(files: Object[]): Promise}}
 */
export const SearchInfo = axios => ({
  /**
   * Update profile personal data
   *
   * @param payload: string
   * @param slug: string
   * @returns Promise
   */
  update(slug, payload) {
    return axios.put(`/v1/profiles/${slug}/search-info`, payload)
  },
  /**
   * Get profile personal data
   *
   * @param slug: string
   * @returns Promise
   */
  get(slug) {
    return axios.get(`/v1/profiles/${slug}/search-info`)
  }
})
